import { render, staticRenderFns } from "./PagePurchaseDetail.vue?vue&type=template&id=8b91e068&"
import script from "./PagePurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./PagePurchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./PagePurchaseDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports